<template>
  <div>
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-8">
      

        <v-container class="mt-4">
      <v-select  label="Membership"></v-select>
       <v-select  label="Frecuency"></v-select>
        
          <v-text-field
            v-model="Amount"
            label="Amount by year"
            required
          ></v-text-field>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
// import VueDropify from "vue-dropify";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  name: "editteamcomponent",
  components: {
    // VueDropify,
    // vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200, 
        addRemoveLinks: true,
      },
      valid: false,
      Amount:"",
      firstname: "",
      lastname: "",
      PhoneNumber: "",
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  methods: {},
};
</script>

<style scoped>
.vue-dropzone {
    padding: 0;
    background: transparent;
    border-style: dashed;
}
</style>


